import { useTranslation } from 'react-i18next';

export default function TrustSection() {
  const { t } = useTranslation('home');

  return (
    <section className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        {/* Header */}
        <div className="mb-10">
          <span className="text-xs tracking-widest uppercase text-foreground-400 font-medium font-serif italic">
            {t('trust_tagline')}
          </span>
          <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-900 mt-2 leading-tight">
            {t('trust_title_line1')}{' '}
            <span className="italic font-semibold text-primary-600">{t('trust_title_line2')}</span>
            <br />
            <span className="font-normal">{t('trust_title_line3')}</span>
          </h2>
          <p className="text-sm text-foreground-500 mt-3 max-w-xl">
            {t('trust_subtitle')}
          </p>
        </div>

        {/* Two stat cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {/* Card 1 - Coral/Primary */}
          <div className="relative rounded-2xl bg-primary-100/80 p-8 md:p-10 overflow-hidden group cursor-default">
            <div className="relative z-10">
              <span className="text-5xl md:text-6xl lg:text-7xl font-heading font-bold text-primary-600">
                {t('trust_stat_1_number')}
              </span>
              <p className="text-sm md:text-base text-foreground-700 mt-4 leading-relaxed max-w-md">
                {t('trust_stat_1_label')}
              </p>
              <p className="text-xs italic text-primary-600 mt-4 font-medium">
                {t('trust_stat_1_tagline')}
              </p>
            </div>
            {/* Decor arrow */}
            <div className="absolute top-6 right-6 w-10 h-10 rounded-full bg-background-50 flex items-center justify-center">
              <i className="ri-arrow-right-up-line text-primary-500"></i>
            </div>
          </div>

          {/* Card 2 - Secondary/Accent */}
          <div className="relative rounded-2xl bg-accent-100/80 p-8 md:p-10 overflow-hidden group cursor-default">
            <div className="relative z-10">
              <span className="text-5xl md:text-6xl lg:text-7xl font-heading font-bold text-accent-600">
                {t('trust_stat_2_number')}
              </span>
              <p className="text-sm md:text-base text-foreground-700 mt-4 leading-relaxed max-w-md">
                {t('trust_stat_2_label')}
              </p>
              <p className="text-xs italic text-accent-600 mt-4 font-medium">
                {t('trust_stat_2_tagline')}
              </p>
            </div>
            {/* Decor arrow */}
            <div className="absolute top-6 right-6 w-10 h-10 rounded-full bg-background-50 flex items-center justify-center">
              <i className="ri-arrow-right-up-line text-accent-500"></i>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}